'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useTooltipTrigger } from '@react-aria/tooltip';
import { mergeProps } from '@react-aria/utils';
import { useTooltipTriggerState } from '@react-stately/tooltip';
import { useRef } from 'react';
import { HIDE_ICON_BUTTON_TOOLTIP } from './icon-button-internal.utils.js';
import { IconButtonTooltipInternal } from './icon-button-tooltip-internal.component.js';
import { Spinner } from '../spinner/spinner.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const IconButton = renderWithRef('IconButton', null, (p, f)=>{
    var d;
    let { children: y, tooltip: m, skin: O = 'secondary', loading: _, 'aria-label': j, type: w, __dangerouslyHideTooltip: g } = p, h = _object_without_properties(p, [
        "children",
        "tooltip",
        "skin",
        "loading",
        'aria-label',
        "type",
        "__dangerouslyHideTooltip"
    ]), P = useRef(null), v = assignRefs(f, P), S = useTooltipTriggerState({
        delay: 0,
        closeDelay: 100
    }), { triggerProps: x, tooltipProps: D } = useTooltipTrigger({
        isDisabled: _ || h.disabled || g === HIDE_ICON_BUTTON_TOOLTIP
    }, S, P), { 'aria-describedby': k } = x, E = _object_without_properties(x, [
        'aria-describedby'
    ]), I = new Set([
        'swan-icon-button',
        `swan-icon-button-skin-${O}`
    ]);
    return _ && I.add('swan-icon-button-loading'), jsxs(Fragment, {
        children: [
            jsxs(RenderComp, {
                root: "button",
                forwardedRef: v,
                classNames: I,
                props: _object_spread_props(_object_spread({}, mergeProps(h, E)), {
                    type: null != w ? w : 'button',
                    'aria-label': null != j ? j : m,
                    'aria-disabled': null !== (d = h['aria-disabled']) && void 0 !== d ? d : _ || void 0
                }),
                children: [
                    y,
                    _ && jsx(Spinner, {
                        accessibleText: "",
                        "aria-hidden": true
                    })
                ]
            }),
            S.isOpen && jsx(IconButtonTooltipInternal, {
                tooltipState: S,
                triggerRef: P,
                triggerTooltipProps: D,
                children: m
            })
        ]
    });
});

export { IconButton };
